module.exports = __webpack_public_path__ + "static/media/louis-hansel-U6-KvV7HlMk-unsplash_mobile.f7696f43.jpg";